export default "__VITE_ASSET__CI6Ryt3l__"